import { createSlice } from "@reduxjs/toolkit";

import {
  updateUnit,
  getUnits,
  addUnit,
  deleteUnit,
  // addUnit,
  // updateUnit,
  // deleteUnit
} from "./thunk";

interface UnitStateType {
  units: Array<any>;
  error?: string | object | null | undefined | unknown;
  success?: string | object | null | undefined | unknown;
}

export const initialState: UnitStateType = {
  units: [],
  error: null,
  success: null,
};

const unitySlice = createSlice({
  name: "units",
  initialState,
  reducers: {
    unitsError(state, action) {
      state.error = action.payload;
    },
    unitsSuccess(state, action) {
      state.success = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getUnits.fulfilled, (state: any, action: any) => {
      state.units = action.payload;
    });
    builder.addCase(getUnits.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(addUnit.fulfilled, (state: any, action: any) => {
      state.units.push(action.payload);
    });
    builder.addCase(addUnit.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(updateUnit.fulfilled, (state: any, action: any) => {
      state.units = state.units.map((unit: any) =>
        unit.id === action.payload.id ? { ...unit, ...action.payload } : unit
      );
    });
    builder.addCase(updateUnit.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(deleteUnit.fulfilled, (state: any, action: any) => {
      state.units = state.units.filter(
        (unit: any) => unit.id !== action.payload
      );
    });
    builder.addCase(deleteUnit.rejected, (state, action) => {
      state.error = action.payload || null;
    });
  },
});

export const { unitsError, unitsSuccess } = unitySlice.actions;

export default unitySlice.reducer;
